import Rails from "@rails/ujs";
import DataConfirmModal from "lib/data-confirm-modal";

DataConfirmModal.start();
Rails.start();
window.Rails = Rails;
